import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const AccountListContainer = styled.div`
    position: relative;
    background: #f5f5f5;
    overflow-y: scroll;
    height: calc(100vh - 10rem);
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    border-radius: 6px;
    padding-bottom: 180px;
    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: ${({ theme }) => theme.scrollOption.width};
    }
    &::-webkit-scrollbar-track {
        margin-top: 0px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
    }
    ${media.mediumDevice`
        &::-webkit-scrollbar {
            display:  none;  
        }
    `}
    ${media.smalDevice`
        flex-direction: column;
       
        &::-webkit-scrollbar {
            display:  none; }`}

    ${media.mobileDevice`
        display: block;
        border-top-left-radius: ${(props) =>
            props.filterDataOpen | props.accountSearchOpen ? 0 : '20px'};
        border-top-right-radius: ${(props) =>
            props.filterDataOpen | props.accountSearchOpen ? 0 : '20px'};
        box-shadow:none;
        border-bottom-left-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        border-bottom-right-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        height: ${(props) =>
            props.showDoubleBanner
                ? 'calc(100vh - 380px)'
                : props.showSingleBanner
                ? 'calc(100vh - 320px)'
                : 'calc(100vh - 250px)'};
        overflow: hidden;
        overflow-y: scroll;
        padding-bottom: 180px;
        &::-webkit-scrollbar {
            display:  none;  
        }`}
`;

export const AccountListProxyWrapper = styled.div`
    ${media.mobileDevice`
        // padding-bottom: 120px;   
    `}
`;

export const BodyTextContainer = styled(Grid)`
    padding-top: 18px;
    padding-left: 0px;
    font-family: 'AvenirNextWorld Regular';
    font-size: 15px;
    color: #202124;
    text-align: left;
    ${media.mediumDevice`
    padding-left: 0px;
`}
    ${media.mobileDevice`
    margin-left: 0;
    padding-left: 24px;
    padding-top: 12px;
    `}
`;

export const PopupContainer = styled.div`
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    ${media.mobileDevice`
    width: 100%;

    `}
`;

export const HeaderGridContainer = styled(Grid)`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 2px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px 6px 0px 0px;
    align-items: center;
    padding: 12px 16px;
    position: sticky;
    top: 0px;
    z-index: 1;
    ${media.smalDevice`
   display: none;
`}
    ${media.mobileDevice`
      display: none !important; 
    `}
`;
export const HeaderTextContainer = styled(Grid)`
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    padding-left: 8px;
    color: #3c3c3c;
    opacity: 1;
`;

export const HeaderTextContainer1 = styled(Grid)`
    text-align: center;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    padding-left: 8px;
    color: #3c3c3c;
    opacity: 1;
`;

export const BodyGridContainer = styled(Grid)`
    height: auto;
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin-top: 10px;
    display: flex;
    padding-bottom: ${(props) =>
        props.paddingBottom ? props.paddingBottom : 'unset'};
    // overflow-y: scroll;

    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: ${({ theme }) => theme.scrollOption.width};
    }
    &::-webkit-scrollbar-track {
        margin-top: 0px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
    }
    ${media.smalDevice`
   text-align:left !important;
`}
    ${media.mediumDevice`
   text-align:left !important;
`}
    ${media.mobileDevice`
    width: auto !important;
    margin: 15px 15px 15px 15px;
    padding: ${({ mbPadding }) => (mbPadding ? mbPadding : '10px 15px')};
`}
`;

export const NameGrid = styled(Grid)``;

export const UserContainer1 = styled(Grid)`
    ${media.mobileDevice`
display: none;
`}
`;

export const UserNameContainer = styled(Grid)`
    ${media.mobileDevice`
width: 150px;
`}
`;

export const UserContainer2Mobile = styled(Grid)`
    display: none;
    ${media.mobileDevice` 
    display: flex;
    align-items: center; 
    flex-direction: row; 
    margin-left: 0px ;    
    `}
`;

export const UserName = styled(Grid)`
    margin: 10px 0 0 24px;
    color: #140f4b;
    font-size: 16px;
    font-family: 'AvenirNextWorld Demi';
    ${media.mobileDevice`
      text-align: left; 
      margin-left: 0px;
    `}
`;

export const DesignationText = styled(Grid)`
    font-size: 12px;
    color: #202124;
    opacity: 0.61;
    margin-left: 24px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
      text-align: left; 
      margin-left: 0px;
    `}
`;

export const UserName1 = styled(Grid)`
    margin-top: 10px;
    color: #3c3c3c;
    margin-left: 8px;
    font-size: 15px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
      display: none;
    `}
`;

export const DesignationText1 = styled(Grid)`
    font-size: 12px;
    color: #3c3c3c;
    opacity: 0.61;
    margin-left: 8px;
    margin-bottom: 10px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
      display: none;
    `}
`;

export const UserName2 = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    color: #3C3C3C;
    font-size: 15px;
    margin-left: 0px;
    font-family: 'AvenirNextWorld Regular';
    `}
`;

export const DesignationText2 = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    text-align: left;
    margin-left: ${(props) => props.marginLeft && props.marginLeft};
    color: #3C3C3C;
    opacity: 0.61;
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    `}
`;

export const ValidDatesGrid = styled(Grid)``;

export const ValidDate = styled(Grid)`
    font-size: 15px;
    color: #3c3c3c;
    margin: 10px 0 0 14px;
    ${media.mobileDevice`
    text-align: left;
    margin: 0 0 0 0;
    `}
`;

export const ValidDate2 = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    color: #3C3C3C;
    opacity: 0.61;
    font-family: 'AvenirNextWorld Regular';
    display:block;
    text-align: left;
    margin-left: 7px;
    font-size: 14px;
    `}
`;

export const ValidDateMobile = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    text-align: left;
    margin: 22px 0 0 0;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    color: #202124;
    opacity: 1;
    display: block;
  `}
`;

export const CreatedBy = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    text-align: left;
    margin: 22px 0 0 0;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    color: #202124;
    opacity: 1;
    display: block;
  `}
`;

export const ValidDate1 = styled(Grid)`
    font-size: 15px;
    color: #3c3c3c;
    margin-top: 10px;
    text-align: center !important;
    ${media.mobileDevice`
    display: none;
  `}
`;

export const CreatedOnGrid = styled(Grid)``;

export const ActionGrid = styled(Grid)`
    text-align: center;
    padding: 10px;
    ${media.mobileDevice`
        padding: 10px 0 10px 10px;
    `}
`;

export const EditIconContainer = styled(Grid)`
    margin: auto;
    width: 97px;
    height: 36px;
    background: ${(props) => (props.backColor ? props.backColor : '#ffffff')};
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 17px;
    opacity: 1;
    ${media.mediumDevice`
    // width: 90px;
    `}
    ${media.smalDevice`
    // width: 90px;
    `}
    ${media.mobileDevice`
    display: none;
    `}
`;

export const StyledImage = styled.img`
    display: flex;
    object-fit: contain;
    cursor: ${(props) => (props.cursor ? props.cursor : 'pointer')};
    padding: 0 0 2px 6px;
    ${media.mobileDevice`
    display: none;
    `}
`;

export const EditContainer = styled(Grid)`
    color: ${(props) => (props.labelColor ? props.labelColor : '#1010eb')};
    padding: 4px 12px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 15px;
    opacity: 1;

    ${media.smalDevice`
    // padding-left: 7px;
    `}
    ${media.mediumDevice`
    // padding-left: 7px;
    `}
    ${media.mobileDevice`
    display: none;
    `}
`;

export const ButtonLabel = styled.label`
    display: flex;
    height: 27px;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 15px;
    color: ${(props) => (props.labelColor ? props.labelColor : '#1010eb')};
    cursor: ${(props) => (props.cursor ? props.cursor : 'pointer')};
    margin-left: 4px;
    ${media.mobileDevice`
    display: none;
    `}
`;

export const EditIconContainerMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    margin: 0 0 auto auto;
    display: block;
    width: 97.39px;
    height: 36px;
    background: ${(props) => (props.backColor ? props.backColor : '#ffffff')};
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #EBEBEB;
    border-radius: 17px;
    opacity: 1;
    `}
`;

export const StyledImageMob = styled.img`
    display: none;
    ${media.mobileDevice`
    display: flex;
    object-fit: contain;
    cursor: pointer;
    padding: 0 0 2px 6px;
    `}
`;

export const EditContainerMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    color: ${(props) => (props.labelColor ? props.labelColor : '#1010eb')};
    padding: 4px 0 0 10px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
    opacity: 1;
    `}
`;

export const ButtonLabelMob = styled.label`
    display: none;
    ${media.mobileDevice`
    display: flex;
    height: 27px;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 15px;
    color: ${(props) => (props.labelColor ? props.labelColor : '#1010eb')};
    cursor: pointer;
    margin-left: 4px;
    
    `}
`;

export const CreatedGrid = styled(Grid)``;

export const Line = styled(Grid)`
    margin-left: 26.5%;
    margin-right: 3%;
    /* margin-top: 15px; */
    /* width: 100%; */
    height: 1px;
    background-color: #707070;
    border: 0.6px solid #707070;
    opacity: 0.3;
    ${media.smalDevice`
    margin-right: 2%;  
  `}
    ${media.mobileDevice`
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    margin-top: 0px;
  `}
`;

export const UserContainerMobile = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: flex;
    width: 100%;
  `}
`;

export const DistrictGrid = styled(Grid)`
    ${media.mobileDevice`
    display:none;
  `}
`;

export const DistrictGridMobile = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
  `}
`;

export const TerritoryGridMobile = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
  `}
`;

export const DistrictName = styled(Grid)`
    margin-left: 18px;
    font-size: 15px;
    font-family: 'AvenirNextWorld Regular';
    color: #202124;
    margin-bottom: 18px;
    ${media.mobileDevice`
    margin-left: 0px;
    margin-bottom: 5px;
  `}
`;

export const TerritoryGrid = styled(Grid)`
    ${media.mobileDevice`
    display:none;
  `}
`;

export const TerritoryName = styled(Grid)`
    margin-left: 10px;
    font-size: 15px;
    font-family: 'AvenirNextWorld Regular';
    color: #202124;
    margin-bottom: 15px;
    word-break: break-word;
    ${media.mobileDevice`
    margin-left: 0px;
  `}
`;

export const DistrictHeading = styled(Grid)`
    margin: 15px 0 0 18px;
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
    ${media.mobileDevice`
    margin-left: 0px;
  `}
`;

export const TerritoryHeading = styled(Grid)`
    margin: 15px 0 0 10px;
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
    ${media.mobileDevice`
    margin: 15px 0 0 14px;
    margin-left: 0px;
  `}
`;

export const DistrictTerritorywrapper = styled.div`
    display: flex;
    ${media.mobileDevice`
        display: block;
    `}
`;
